export const images = {
    flagUk: require('./flag-uk.png'),
    flagVn: require('./flag-vn.png'),
    fbIcon: require('./fb-icon.png'),
    messengerIcon: require('./messenger-icon.png'),
    instaIcon: require('./insta-icon.png'),
    pricing: require('./pricing-optimized.jpg'),
    nailService: require('./nail-service.png'),
    nailService2: require('./nail-service2.png'),
    nailService3: require('./nail-service3.png'),
    nailService4: require('./nail-service4.png'),
    leftArrow: require('./left-arrow.png'),
    main_logo:  require('./main-logo.png'),
    header_primary: require('./header_primary.jpg'),
    header_primary02: require('./header_primary02.jpg'),
    banner01: require('./banner01.jpg'),
    banner02: require('./banner02.jpg'),
    banner03: require('./banner03-optimized.jpg'),
    nail01: require('./nail01-optimized.jpg'),
    nail02: require('./nail02-optimized.jpg'),
    nail03: require('./nail03-optimized.jpg'),
    nail04: require('./nail04-optimized.jpg'),
    nail05: require('./nail05-optimized.jpg'),
    nail06: require('./nail06-optimized.jpg'),
    nail07: require('./nail07-optimized.jpg'),
    nail08: require('./nail08-optimized.jpg'),
    nail09: require('./nail09-optimized.jpg'),
    nail10: require('./nail10-optimized.jpg'),
    nail11: require('./nail11-optimized.jpg'),
    nail12: require('./nail12-optimized.jpg'),
    popup: require('./popup.jpg'),
    pedicure: require('./pedicure-optimized.jpg')
};
